module.exports = "/static/assets/91f2e12fe429965b5b219f289cf6aa31.png";